import { setUpdatePhoneModalOpen } from '@perpay-web/components/actions/userVerificationModal';
import { useAnimatedModal } from '@perpay-web/components/base/Modal/useAnimatedModal';
import { useModal } from '@perpay-web/components/base/Modal/useModal';
import { updateUserInfoContextSuccess } from '@perpay-web/fintech/actions/entities/userInfo';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useUpdatePhoneNumberModal = () => {
    const { isModalOpen, setIsModalOpen } = useModal();

    const {
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    } = useAnimatedModal({
        isModalOpen,
        setIsModalOpen,
    });

    return {
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useUpdatePhoneNumberModal();

        useActionObservableCallback(
            hookAction$,
            setUpdatePhoneModalOpen.type,
            (value) => hook.setIsAnimatedModalOpen(value),
        );

        useActionObservableCallback(
            hookAction$,
            updateUserInfoContextSuccess.type,
            () => hook.setIsAnimatedModalOpen(false),
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };
    return Provider;
};

const [UpdatePhoneNumberModalProvider, useUpdatePhoneNumberModalContext] =
    createContextProvider(providerFactory);

export { UpdatePhoneNumberModalProvider, useUpdatePhoneNumberModalContext };
